import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { TrialDetail } from "../../../../core/models/trial-detail.model";
import { TrialSupportContactsComponent } from "./trial-support-contacts/trial-support-contacts.component";
import { TrialSupportInfoComponent } from "./trial-support-info/trial-support-info.component";
import { SegmentControlComponent } from "../../../../shared/segment-control/segment-control.component";
import { ModalComponent } from "../../../../shared/modal/modal.component";
import { SegmentStyle } from "../../../../shared/segment-control/segment-style.enum";

@Component({
  selector: 'app-trial-support',
  templateUrl: './trial-support.component.html',
  styleUrl: './trial-support.component.scss'
})
export class TrialSupportComponent {
  @ViewChild('contactsComponent') contactsComponent: TrialSupportContactsComponent;
  @ViewChild('supportInfo') supportInfoComponent: TrialSupportInfoComponent;
  @ViewChild('segmentControl') segmentControl: SegmentControlComponent;
  @ViewChild('unsavedModal') unsavedModal: ModalComponent;

  @Input() trial: TrialDetail;

  @Output() contactsHasChanges = new EventEmitter<boolean>(false);

  protected currentSegment: number = 0;
  private pendingSegment: number | null = null;

  protected readonly SegmentStyle = SegmentStyle;

  private get hasUnsavedChanges(): boolean {
    return (this.contactsComponent?.hasChanges || this.supportInfoComponent?.hasChanges) ?? false;
  }

  segmentIndexChanged(index: number) {
    if (index === this.currentSegment) return;

    if (this.hasUnsavedChanges) {
      this.pendingSegment = index;
      // Revert the segment control back to the current segment
      this.segmentControl.selectSegmentAtIndex(this.currentSegment);
      this.unsavedModal.show();
    } else {
      this.currentSegment = index;
    }
  }

  onConfirmSegmentSwitch() {
    this.unsavedModal.hide();
    this.setContactsHasChanges(false);
    this.currentSegment = this.pendingSegment;
    this.segmentControl.selectSegmentAtIndex(this.pendingSegment);
    this.pendingSegment = null;
  }

  onCancelSegmentSwitch() {
    this.unsavedModal.hide();
    this.pendingSegment = null;
  }

  setContactsHasChanges(hasChanges: boolean) {
    if (this.contactsComponent) {
      this.contactsComponent.hasChanges = false;
    }
    if (this.supportInfoComponent) {
      this.supportInfoComponent.hasChanges = false;
    }
    this.contactsHasChanges.emit(hasChanges);
  }
}
